import { Alert, Box, Divider, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import React, {
  useCallback,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";
import AgGridTable from "../utilities/AgGridTable";
import CustomTooltip from "./customTooltip";
import Decline from "./Decline";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import jwtDecode from "jwt-decode";
import { forwardRef } from "react";
import { useEffect } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import { grey } from "@mui/material/colors";
import GroupRowInnerRendererSDP from "./GroupRowInnerRendererSDP";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { AgGridReact } from "ag-grid-react";
import { useTheme } from "@mui/material/styles";

const SDPDiscount = forwardRef((props, ref) => {
  const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [error, setError] = useState();
  const [expandedGroups, setExpandedGroups] = useState([]);
  const [successMsg, setSuccessMsg] = useState();
  const [hideSDPColumns, setHideSDPColumns] = useState(false);
  const [hideSDRColumns, setHideSDRColumns] = useState(false);
  const [autoSizeMode, setAutoSizeMode] = useState(true);
  const [editableRow, setEditable] = useState(true);
  const [selectedRowsID, setSelectedRowsID] = useState([]);
  const [totalsGroup, setTotalsGroup] = useState();
   const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
    const stateRef = useRef();
    const saveGridStateName = 'sdp-discount-list';
    const gridStyle = useMemo(
      () => ({ height: "calc(100% - 25px)", width: "100%" }),
      []
    );
  const navigate=useNavigate()
var filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
    const date = new Date(dateAsString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    if (formattedDate == null) return -1;
    var dateParts = formattedDate.split("/");
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0]),
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime() ) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight ) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight ) {
      return 1;
    }
    return 0;
  },
 maxValidYear:new Date().getFullYear(),
};
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
const DeclineComponent = (params) => {
    const [deleteOpen,setDeleteOpen]=useState(false);
    const data = params;
    
   
    const handleDeleteSpecialDiscount=async()=>{
      let id=params?.data?.id;
      try {
            const response = await OAuthService.deleteData(
                     discountUrl +`api/specialDiscounts`,id
                   
                  );
                  toast.success("Discount Deleted successfully!")
                  setDeleteOpen(false)
                 const rowNode = params.api.getRowNode(id);
    if (rowNode) {
      params.api.applyTransaction({ remove: [rowNode.data] });
    }

          } catch (error) {
             toast.error(error?.response?.data?.errorMessage || error.message);
          }

    }

    return (
      <div className="flex item-center justify-center">
        <Tooltip title={"Delete"}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setDeleteOpen(true);
            }}
            disabled={
              params?.data?.status !== "WAITING" &&
              params?.data?.status !== "PENDING"
            }
          >
            <FuseSvgIcon
              size={14}
              className={
                params?.data?.status === "WAITING" ||
                params?.data?.status === "PENDING"
                  ? "text-red-600"
                  : "text-stone-500"
              }
            >
              heroicons-outline:trash
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>

        <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)  } onClick={(e) => e.stopPropagation()}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent id="alert-dialog-description">
            <DialogContentText>
              {`Are you sure  want to delete Order ${params?.data?.project}  special discount?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteOpen(false)} autoFocus>
              No
            </Button>
            <Button onClick={handleDeleteSpecialDiscount}>Yes</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const showDocument = (document) => {
    handleDownloadAttachment(document);
  };

  const showStatusIcon = (props) => {
    let statusIcon = "";
    if (props?.data?.sdpStatus === "PENDING") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#fe9705", marginRight: 4 }}>
            material-solid:access_time_filled
          </FuseSvgIcon>
          {props.value}
        </>
      );
    }
    if (props?.data?.sdpStatus === "WAITING") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#fcd260", marginRight: 4 }}>
            material-solid:timelapse
          </FuseSvgIcon>
          {props.value}
        </>
      );
    }
    if (props?.data?.sdpStatus === "APPROVED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#3ac430", marginRight: 4 }}>
            material-solid:check_circle
          </FuseSvgIcon>
          {props.value}
        </>
      );
    }
    if (props?.data?.sdpStatus === "REJECTED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#d11313", marginRight: 4 }}>
            material-solid:do_not_disturb
          </FuseSvgIcon>
          {props.value}
        </>
      );
    }
    if (props?.data?.sdpStatus === "DECLINED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#3ac430", marginRight: 4 }}>
            material-solid:cancel
          </FuseSvgIcon>
          {props?.value}
        </>
      );
    }
    return (
      <p className="flex items-center">
        {props.column.colId === "customerNum" && props.value
          ? statusIcon
          : props.value}
      </p>
    );
  };
      useEffect(() => {
          if (saveGridStateName) {
            stateRef.current = {
              screenName: saveGridStateName,
              screenState: stateData,
            };
          }
        }, [stateData]);
   const onFirstDataRendered = (params) => {
    const savedState = localStorage.getItem(`gridState-${saveGridStateName}`);
    if (savedState) {
      try {
        const data = JSON.parse(savedState);
        if (data.screenState?.filter) {
          params.api.setFilterModel(data.screenState.filter);
        }
        if (data.screenState?.columnState) {
          params.columnApi.applyColumnState({
            state: data.screenState.columnState,
            applyOrder: true,
          });
        }
        if (data.screenState?.columnGroupState) {
          params.columnApi.setColumnGroupState(data.screenState.columnGroupState);
        }
      } catch (err) {
        console.error('Failed to load grid state:', err);
      }
    }
  
  };
   useEffect(() => {
          const unloadCallback = () => {
            if (saveGridStateName && stateRef.current) {
              localStorage.setItem(`gridState-${saveGridStateName}`, JSON.stringify(stateRef.current));
            }
          };
      
          window.addEventListener("beforeunload", unloadCallback);
          return () => {
            window.removeEventListener("beforeunload", unloadCallback);
            unloadCallback();
          };
        }, []);
   const onFilterChanged = (params) => {
    stateData.filter = params.api.getFilterModel();
    setStateData({ ...stateData });
  };
  
    const onColumnStateChanged = (params) => {
      stateData.columnState = params.columnApi.getColumnState();
      stateData.columnGroupState = params.columnApi.getColumnGroupState();
      setStateData({ ...stateData });
    };
  
    const onColumnGroupChange = (params) => {
      onColumnStateChanged(params);
    };

 
 const goToRoleEdit = useCallback(
      (data) => {
        if (data?.id !== undefined) {
          navigate("/special-discount-details-sdp/" + data.id);
        }
      },
      [navigate],
    );
    const onRowDoubleClicked = (params) => {
      if (isMobile) return;
      goToRoleEdit(params?.data);
    };

   const onRowClicked = (params) => {
  if (!isMobile) return;

  const target = params?.event?.target;
  if (target?.closest?.("button, a, input, .MuiIconButton-root, [role='button']")) {
    return;
  }

  if (params?.column?.getColId?.() === "actions") return;

  goToRoleEdit(params?.data);
};
  const discountUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
     const STATUS_COLORS = {
    WAITING: { bg: "#fcd260", text: "#5c4400" },
    PENDING: { bg: "#fe9705", text: "#ffffff" },
    APPROVED: { bg: "#3ac430", text: "#ffffff" },
    REJECTED: { bg: "#d11313", text: "#ffffff" },
    DECLINED: { bg: "#8c1010", text: "#ffffff" },
  };

  const showStatusBadge = (params) => {
    const value = params?.value;
    const colors = STATUS_COLORS[value] || { bg: "#9e9e9e", text: "#ffffff" };

    if (!value) return null;

    return (
      <span
        style={{
          display: "inline-block",
          padding: "2px 10px",
          borderRadius: 999,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 0.3,
          backgroundColor: colors.bg,
          color: colors.text,
          whiteSpace: "nowrap",
        }}
      >
        {value}
      </span>
    );
  };
   const handleDateFormat = (props) => {
      return props.value && moment(props.value).format("DD-MM-YYYY");
    };
  
    const [columnDefsSDP, setColumnDefsSDP] = useState([
      // { field: 'Group', editable: false, cellRenderer: (params) => showStatusIcon(params), },
      {
        field: "customerId",
        headerName: "Customer No",
        cellRenderer: (params) => showStatusIcon(params),
        enableRowGroup: true,
        minWidth: 80,
        cellStyle: {
          justifyContent: "center",
          textAlign: "center", // Center the cell data horizontally
        },
      },
      {
        field: "customerName",
        headerName: "Customer",
        minWidth: 250,
        enableRowGroup: true,
      },
      {
        field: "territory",
        headerName: "Territory",
        minWidth: 50,
        enableRowGroup: true,
        cellStyle: {
          justifyContent: "center",
          textAlign: "center",
        },
      },

      {
        field: "vendorName",
        headerName: "Product",
        enableRowGroup: true,

        minWidth: 150,
      },
      {
        field: "orderCategory",
        enableRowGroup: true,
        headerName: "Order Category",
        minWidth: 60,
        cellStyle: {
          justifyContent: "center",
          textAlign: "center",
        },
      },
      {
        field: "project",
        enableRowGroup: true,
        headerName: "Order Reference",
        minWidth: 60,
        cellStyle: {
          justifyContent: "center",
          textAlign: "center",
        },
      },
      {
        field: "projectName",
        enableRowGroup: true,
        headerName: "Project Name",
        minWidth: 100,
      },
      {
        field: "phase",
        enableRowGroup: true,
        headerName: "Project Phase",
        minWidth: 70,
        cellStyle: {
          justifyContent: "center",
          textAlign: "center",
        },
      },

      {
        field: "status",
        headerName: "SDP Status",
        minWidth: 70,
        minWidth: 110,
        cellRenderer: showStatusBadge,
        cellStyle: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      },
      {
        field: "createdByUser",
        enableRowGroup: true,
        headerName: "Requested By",
        minWidth: 120,
      },
      {
        field: "requestedDate",
        enableRowGroup: true,
        headerName: "Requested Date",
        cellRenderer: handleDateFormat,
        minWidth: 120,
        filter: "agDateColumnFilter",
        filterParams,
        cellStyle: {
          justifyContent: "center",
          textAlign: "center",
        },
      },
      {
        field: "approvedBy",
        enableRowGroup: true,
        headerName: "Approved By/Rejected By",
        minWidth: 120,
      },
      {
        field: "approvedDate",
        enableRowGroup: true,
        cellRenderer: handleDateFormat,
        minWidth: 120,
        headerName: "Approved Date/Rejected Date",
        filter: "agDateColumnFilter",
        filterParams,
        cellStyle: {
          justifyContent: "center",
          textAlign: "center",
        },
      },

      {
        colId: "actions",
        minWidth: 90,
        maxWidth: 90,
        editable: false,
        floatingFilter: false,
        filter: false,
        sortable: false,
        resizable: false,
        pinned: "right",
        cellRenderer: DeclineComponent,
      },
    ]);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

 

  const handleUpdateSDPCellValue = () => {
    if (selectedRows.length > 0) {
      const colId1 = "sdpWg1";
      const colId2 = "sdpWg2";
      const updateData = rowData.map((row) => {
        if (selectedRows.find((selectedRow) => selectedRow.id === row.id)) {
          row[colId1]= props.wg1SDP !== "" ? props.wg1SDP : row?.sdpWg1;
          row[colId2]= props.wg1SDP !== "" ? props.wg2SDP : row?.sdpWg2;
          if (row?.stdDiscWg1 || row?.sdrWg1) {
            row.cumDiscWg1 =
              100 -
              (((100 - Number(row?.rcblStdDiscWg1)) *
                (100 - Number(row?.sdrWg1))) /
                100);
          } else {
            row.cumDiscWg1 = 0;
          }
  
          if (row?.rcblStdDiscWg2 || row?.sdrWg2) {
            row.cumDiscWg2 =
              100 -
              (((100 - Number(row?.rcblStdDiscWg2)) *
                (100 - Number(row?.sdrWg2))) /
                100);
          } else {
            row.cumDiscWg2 = 0;
          }
            
          if (
            row?.rcblStdDiscWg1 ||
            row?.cumDiscWg2 ||
            row?.lpWg1 ||
            row?.lpWg2
          ) {
            row.nmeRcblStd =
              Number(row?.lpWg1) -
              Number(row?.lpWg1) * (Number(row?.rcblStdDiscWg1) / 100) +
              (Number(row?.lpWg2) -
                Number(row?.lpWg2) * (Number(row?.cumDiscWg2) / 100));
          } else {
            row.nmeRcblStd = "";
          }      
  
          if (row?.pblStdDiscWg1 || row?.sdpWg1) {
            row.pblCumDiscWg1 =
              100 -
              ((100 - Number(row?.pblStdDiscWg1)) *
                (100 - Number(row?.sdpWg1))) /
                100;
          } else {
            row.pblCumDiscWg1 = 0;
          }
  
          if (
            row?.cumDiscWg1 ||
            row?.cumDiscWg2 ||
            row?.lpWg1 ||
            row?.lpWg2
          ) {
            row.nmeRcbl =
             Number(row?.lpWg1) -
             Number(row?.lpWg1) * (Number(row?.cumDiscWg1) / 100) +
             Number(row?.lpWg2) -
             Number(row?.lpWg2) * (Number(row?.cumDiscWg2) / 100);
            // data.nmeRcbl = (Number(row?.rcblStdDiscWg1) -
            //   Number(row?.rcblStdDiscWg1) * (Number(row?.cumDiscWg1))) +
            //   (Number(row?.lpWg2) -
            //     Number(row?.lpWg2) * (Number(row?.pblCumDiscWg1)));
          } else {
            row.nmeRcbl = "";
          }
  
          if (row?.pblStdDiscWg2 || row?.sdpWg2) {
            row.pblCumDiscWg2 =
              100 -
              ((100 - Number(row?.pblStdDiscWg2)) *
                (100 - Number(row?.sdpWg2))) /
                100;
          } else {
            row.pblCumDiscWg2 = 0;
          }
  
          if (
            row?.cumDiscWg2 ||
            row?.cumDiscWg1 ||
            row?.lpWg1 ||
            row?.lpWg2
          ) {
            row.nmeRcblAfterSdr =
              Number(row?.lpWg1) -
              Number(row?.lpWg1) * (Number(row?.cumDiscWg1) / 100) +
              (Number(row?.lpWg2) -
                Number(row?.lpWg2) * (Number(row?.cumDiscWg2) / 100));
          } else {
            row.nmeRcblAfterSdr = "";
          }      
          
          if (
            row?.pblCumDiscWg1 ||
            row?.pblCumDiscWg2 ||
            row?.lpWg1 ||
            row?.lpWg2
          ) {
            row.nmePbl =
              Number(row?.lpWg1) -
             (Number(row?.lpWg1) * (Number(row?.pblCumDiscWg1) / 100)) +
              (Number(row?.lpWg2) -
                Number(row?.lpWg2) * (Number(row?.pblCumDiscWg2) / 100));
          } else {
            row.nmePbl = 0;
          }
           
          if (row?.nmeRcblAfterSdr || row?.nmePbl) {
            row.marginAftSplDisc =
              Number(row?.nmeRcblAfterSdr) - Number(row?.nmePbl);
          } else {
            row.marginAftSplDisc = "";
          }
  
          if (row?.marginAftSplDisc && row?.nmeRcblAfterSdr) {
            row.marginAftSplDiscPercent =
              (Number(row?.marginAftSplDisc) / Number(row?.nmeRcblAfterSdr))* 100;
          } else {
            row.marginAftSplDiscPercent = "";
          }
  
          if (row?.nmeRcblStd || row?.nmeRcblAfterSdr) {
            row.gestureToCustomer =
              Number(row?.nmeRcblStd) - Number(row?.nmeRcblAfterSdr);
          } else {
            row.gestureToCustomer = "";
          }
  
          if (row?.gestureToCustomer || row?.nmeRcblStd) {
            row.gesture =
              (Number(row?.gestureToCustomer) / Number(row?.nmeRcblStd))*100;
          } else {
            row.gesture = "";
          }
  
  
          if (row?.nmeRcblStd || row?.nmePbl) {
            row.stdMargin = Number(row?.nmeRcblStd) - Number(row?.nmePbl);
          } else {
            row.stdMargin = "";
          }
  
  
          if (
            row?.pblStdDiscWg1 ||
            row?.pblStdDiscWg2 ||
            row?.lpWg1 ||
            row?.lpWg2
          ) {
            row.nmePblStd =
              Number(row?.lpWg1) -
              Number(row?.lpWg1) * (Number(row?.pblStdDiscWg1) / 100) +
              (Number(row?.lpWg2) -
                Number(row?.lpWg2) * (Number(row?.pblStdDiscWg2) / 100));
          } else {
            row.nmePblStd = 0;
          }
  
          if (
            row?.pblCumDiscWg1 ||
            row?.pblCumDiscWg2 ||
            row?.lpWg1 ||
            row?.lpWg2
          ) {
            row.nmePblAfterSdr =
              Number(row?.lpWg1) -
              Number(row?.lpWg1) * (Number(row?.pblCumDiscWg1) / 100) +
              (Number(row?.lpWg2) -
                Number(row?.lpWg2) * (Number(row?.pblCumDiscWg2) / 100));
          } else {
            row.nmePblAfterSdr = 0;
          }
  
          if (row?.nmePblStd || row?.nmeRcbl) {
            row.stdPblMargin = Number(row?.nmeRcbl) - Number(row?.nmePblStd);
          } else {
            row.stdPblMargin = 0;
          }
  
          if (row?.nmePblAfterSdr || row?.nmePbl) {
            row.pblMarginAftSplDisc =
              Number(row?.nmeRcbl) - Number(row?.nmePblAfterSdr);
          } else {
            row.pblMarginAftSplDisc = 0;
          }
  
          if (row?.marginAftSplDisc && row?.nmePblAfterSdr) {
            row.pblMarginAftSplDiscPercent =
              (Number(row?.marginAftSplDisc) / Number(row?.nmeRcbl))*100;
          } else {
            row.pblMarginAftSplDiscPercent = 0;
          }
  
          if (row?.nmePblStd || row?.nmePblAfterSdr) {
            row.gestureToPbl =
              Number(row?.nmePblStd) - Number(row?.nmePblAfterSdr);
          } else {
            row.gestureToPbl = 0;
          }
  
          if (row?.gestureToPbl || row?.nmePblStd) {
            row.gesturePbl =
              (Number(row?.gestureToPbl) / Number(row?.nmePblStd))*100;
          } else {
            row.gesturePbl = 0;
          }

          return {
            ...row,
          };
        } else {
          return row;
        }
      });
      setRowData(updateData);
      setSelectedRows([]);
     
    }
  };

  

  const onCellValueChanged = (params) => {
    const { colDef, data, newValue } = params;
    if (colDef.field === "sdpWg1" || colDef.field === "sdpWg2") {

      const updatedRowData = rowData.map((row) =>{
        if(row?.id === params.data.id){
          if (params?.data?.stdDiscWg1 || params?.data?.sdrWg1) {
            row.cumDiscWg1 =
              100 -
              (((100 - Number(params?.data?.rcblStdDiscWg1)) *
                (100 - Number(params?.data?.sdrWg1))) /
                100);
          } else {
            row.cumDiscWg1 = 0;
          }
  
          if (params?.data?.rcblStdDiscWg2 || params?.data?.sdrWg2) {
            row.cumDiscWg2 =
              100 -
              (((100 - Number(params?.data?.rcblStdDiscWg2)) *
                (100 - Number(params?.data?.sdrWg2))) /
                100);
          } else {
            row.cumDiscWg2 = 0;
          }
            
          if (
            params?.data?.rcblStdDiscWg1 ||
            params?.data?.cumDiscWg2 ||
            params?.data?.lpWg1 ||
            params?.data?.lpWg2
          ) {
            row.nmeRcblStd =
              Number(params?.data?.lpWg1) -
              Number(params?.data?.lpWg1) * (Number(params?.data?.rcblStdDiscWg1) / 100) +
              (Number(params?.data?.lpWg2) -
                Number(params?.data?.lpWg2) * (Number(params?.data?.cumDiscWg2) / 100));
          } else {
            row.nmeRcblStd = "";
          }      
  
          if (params?.data?.pblStdDiscWg1 || params?.data?.sdpWg1) {
            row.pblCumDiscWg1 =
              100 -
              ((100 - Number(params?.data?.pblStdDiscWg1)) *
                (100 - Number(params?.data?.sdpWg1))) /
                100;
          } else {
            row.pblCumDiscWg1 = 0;
          }
  
          if (
            params?.data?.cumDiscWg1 ||
            params?.data?.cumDiscWg2 ||
            params?.data?.lpWg1 ||
            params?.data?.lpWg2
          ) {
            row.nmeRcbl =
             Number(params?.data?.lpWg1) -
             Number(params?.data?.lpWg1) * (Number(params?.data?.cumDiscWg1) / 100) +
             Number(params?.data?.lpWg2) -
             Number(params?.data?.lpWg2) * (Number(params?.data?.cumDiscWg2) / 100);
            // data.nmeRcbl = (Number(params?.data?.rcblStdDiscWg1) -
            //   Number(params?.data?.rcblStdDiscWg1) * (Number(params?.data?.cumDiscWg1))) +
            //   (Number(params?.data?.lpWg2) -
            //     Number(params?.data?.lpWg2) * (Number(params?.data?.pblCumDiscWg1)));
          } else {
            row.nmeRcbl = "";
          }
  
          if (params?.data?.pblStdDiscWg2 || params?.data?.sdpWg2) {
            row.pblCumDiscWg2 =
              100 -
              ((100 - Number(params?.data?.pblStdDiscWg2)) *
                (100 - Number(params?.data?.sdpWg2))) /
                100;
          } else {
            row.pblCumDiscWg2 = 0;
          }
  
          if (
            params?.data?.cumDiscWg2 ||
            params?.data?.cumDiscWg1 ||
            params?.data?.lpWg1 ||
            params?.data?.lpWg2
          ) {
            row.nmeRcblAfterSdr =
              Number(params?.data?.lpWg1) -
              Number(params?.data?.lpWg1) * (Number(params?.data?.cumDiscWg1) / 100) +
              (Number(params?.data?.lpWg2) -
                Number(params?.data?.lpWg2) * (Number(params?.data?.cumDiscWg2) / 100));
          } else {
            row.nmeRcblAfterSdr = "";
          }      
          
          if (
            params?.data?.pblCumDiscWg1 ||
            params?.data?.pblCumDiscWg2 ||
            params?.data?.lpWg1 ||
            params?.data?.lpWg2
          ) {
            row.nmePbl =
              Number(params?.data?.lpWg1) -
             (Number(params?.data?.lpWg1) * (Number(params?.data?.pblCumDiscWg1) / 100)) +
              (Number(params?.data?.lpWg2) -
                Number(params?.data?.lpWg2) * (Number(params?.data?.pblCumDiscWg2) / 100));
          } else {
            row.nmePbl = 0;
          }
           
          if (params?.data?.nmeRcblAfterSdr || params?.data?.nmePbl) {
            row.marginAftSplDisc =
              Number(params?.data?.nmeRcblAfterSdr) - Number(params?.data?.nmePbl);
          } else {
            row.marginAftSplDisc = "";
          }
  
          if (params?.data?.marginAftSplDisc && params?.data?.nmeRcblAfterSdr) {
            row.marginAftSplDiscPercent =
              (Number(params?.data?.marginAftSplDisc) / Number(params?.data?.nmeRcblAfterSdr))* 100;
          } else {
            row.marginAftSplDiscPercent = "";
          }
  
          if (params?.data?.nmeRcblStd || params?.data?.nmeRcblAfterSdr) {
            row.gestureToCustomer =
              Number(params?.data?.nmeRcblStd) - Number(params?.data?.nmeRcblAfterSdr);
          } else {
            row.gestureToCustomer = "";
          }
  
          if (params?.data?.gestureToCustomer || params?.data?.nmeRcblStd) {
            row.gesture =
              (Number(params?.data?.gestureToCustomer) / Number(params?.data?.nmeRcblStd))*100;
          } else {
            row.gesture = "";
          }
  
  
          if (params?.data?.nmeRcblStd || params?.data?.nmePbl) {
            row.stdMargin = Number(params?.data?.nmeRcblStd) - Number(params?.data?.nmePbl);
          } else {
            row.stdMargin = "";
          }
  
  
          if (
            params?.data?.pblStdDiscWg1 ||
            params?.data?.pblStdDiscWg2 ||
            params?.data?.lpWg1 ||
            params?.data?.lpWg2
          ) {
            row.nmePblStd =
              Number(params?.data?.lpWg1) -
              Number(params?.data?.lpWg1) * (Number(params?.data?.pblStdDiscWg1) / 100) +
              (Number(params?.data?.lpWg2) -
                Number(params?.data?.lpWg2) * (Number(params?.data?.pblStdDiscWg2) / 100));
          } else {
            row.nmePblStd = 0;
          }
  
          if (
            params?.data?.pblCumDiscWg1 ||
            params?.data?.pblCumDiscWg2 ||
            params?.data?.lpWg1 ||
            params?.data?.lpWg2
          ) {
            row.nmePblAfterSdr =
              Number(params?.data?.lpWg1) -
              Number(params?.data?.lpWg1) * (Number(params?.data?.pblCumDiscWg1) / 100) +
              (Number(params?.data?.lpWg2) -
                Number(params?.data?.lpWg2) * (Number(params?.data?.pblCumDiscWg2) / 100));
          } else {
            row.nmePblAfterSdr = 0;
          }
  
          if (params?.data?.nmePblStd || params?.data?.nmeRcbl) {
            row.stdPblMargin = Number(params?.data?.nmeRcbl) - Number(params?.data?.nmePblStd);
          } else {
            row.stdPblMargin = 0;
          }
  
          if (params?.data?.nmePblAfterSdr || params?.data?.nmePbl) {
            row.pblMarginAftSplDisc =
              Number(params?.data?.nmeRcbl) - Number(params?.data?.nmePblAfterSdr);
          } else {
            row.pblMarginAftSplDisc = 0;
          }
  
          if (params?.data?.marginAftSplDisc && params?.data?.nmePblAfterSdr) {
            row.pblMarginAftSplDiscPercent =
              (Number(params?.data?.marginAftSplDisc) / Number(params?.data?.nmeRcbl))*100;
          } else {
            row.pblMarginAftSplDiscPercent = 0;
          }
  
          if (params?.data?.nmePblStd || params?.data?.nmePblAfterSdr) {
            row.gestureToPbl =
              Number(params?.data?.nmePblStd) - Number(params?.data?.nmePblAfterSdr);
          } else {
            row.gestureToPbl = 0;
          }
  
          if (params?.data?.gestureToPbl || params?.data?.nmePblStd) {
            row.gesturePbl =
              (Number(params?.data?.gestureToPbl) / Number(params?.data?.nmePblStd))*100;
          } else {
            row.gesturePbl = 0;
          }
          return row;
        }else{
          return row;
        }
    });

      setRowData(updatedRowData);
      setTimeout(() => {
        if (expandedGroups.length > 0) {
          expandedGroups.forEach((groupId) => {
            gridRef.current.api.forEachNode((rowNode, index) => {
              if (
                rowNode.field === groupId.field &&
                rowNode.key === groupId.key
              ) {
                rowNode.setExpanded(true);
              }
            });
          });
          selectedRowsID.forEach((id) => {
            const rowNode = gridApi.getRowNode(id);
            if (rowNode) {
              rowNode.setSelected(true);
            }
          });
        }
      }, 50);

      // const updatedValue = 100 - (((100 - data.rcblStdDiscWg1) * (100 - newValue)) / 100); // 100 - (((100 - params.data?.rcblStdDiscWg1) * (100 - params.data?.sdrWg1)) / 100)
      // cumDiscWg1 = updatedValue
      // gridApi.refreshCells()
    }
  };

  const handleSDPSubmit = async () => {
    const model = selectedRows.map((item) => ({
      orderId: [item.id],
      sdpWg1: Number(item.sdpWg1) || 0,
      sdpWg2: Number(item.sdpWg2) || 0,
    }));

    try {
      await OAuthService.addData(discountUrl + "api/addSDPDiscount", model);
      setSuccessMsg("SDP discount saved successfully.");
      loadSDPDiscount(props.filterPagination);
      props.clearSDPValue();
      return "SDP discount saved successfully..";
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };

  const toggleAutoSize = () => {
    if (gridRef.current) {
      if (autoSizeMode) {
        const allColumnIds = [];
        gridRef.current.columnApi.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef.current.columnApi.autoSizeColumns(allColumnIds);
      } else {
        gridRef.current.api.sizeColumnsToFit();
      }
      setAutoSizeMode(!autoSizeMode);
    }
  };

  const toggleSDPColumns = () => {
    const columnsToHide = [
      "sdpWg1",
      "sdpWg2",
      "pblStdDiscWg1",
      "pblCumDiscWg1",
      "pblStdDiscWg2",
      "pblCumDiscWg2",
      "pblCumDiscWg2",
      "gesturePbl",
      "gestureToPbl",
      "pblMarginAftSplDiscPercent",
      "pblMarginAftSplDisc",
      "stdPblMargin",
      "nmePblAfterSdr",
      "nmePblStd",
      "nmePbl",
    ];
    setHideSDPColumns((prevHideSDPColumns) => !prevHideSDPColumns);

    
    gridRef.current.columnApi.applyColumnState({
      state: [
        {colId: "sdpWg1",hide: !hideSDPColumns},
        {colId: "sdpWg2",hide: !hideSDPColumns},
        {colId: "pblStdDiscWg1",hide: !hideSDPColumns},
        {colId: "pblCumDiscWg1",hide: !hideSDPColumns},
        {colId: "pblStdDiscWg2",hide: !hideSDPColumns},
        {colId: "pblCumDiscWg2",hide: !hideSDPColumns},
        {colId: "pblCumDiscWg2",hide: !hideSDPColumns},
        {colId: "gesturePbl",hide: !hideSDPColumns},
        {colId: "gestureToPbl",hide: !hideSDPColumns},
        {colId: "pblMarginAftSplDiscPercent",hide: !hideSDPColumns},
        {colId: "pblMarginAftSplDisc",hide: !hideSDPColumns},
        {colId: "stdPblMargin",hide: !hideSDPColumns},
        {colId: "nmePblAfterSdr",hide: !hideSDPColumns},
        {colId: "nmePblStd",hide: !hideSDPColumns},
        {colId: "nmePbl",hide: !hideSDPColumns},
      ]
    })
    gridRef.current.api.refreshCells();
  };

  const toggleSDRColumns = () => {
    const columnsToHide = [
      "sdrWg1",
       "sdrWg2",
       "rcblStdDiscWg1",
       "rcblStdDiscWg2",
       "nmeRcbl",
       "nmeRcblStd",
       "nmeRcblAfterSdr",
       "stdMargin",
       "marginAftSplDisc",
       "marginAftSplDiscPercent",
       "gestureToCustomer",
       "gesture",
      ];
    setHideSDRColumns((prevHideSDRColumns) => !prevHideSDRColumns);

   
    gridRef.current.columnApi.applyColumnState({
      state: [
        { colId: "sdrWg1", hide: !hideSDRColumns},
        { colId: "sdrWg2", hide: !hideSDRColumns},  
        { colId: "rcblStdDiscWg1", hide: !hideSDRColumns},
        { colId: "rcblStdDiscWg2", hide: !hideSDRColumns},
        { colId: "nmeRcbl", hide: !hideSDRColumns},
        { colId: "nmeRcblStd", hide: !hideSDRColumns},
        { colId: "nmeRcblAfterSdr", hide: !hideSDRColumns},
        { colId: "stdMargin", hide: !hideSDRColumns},
        { colId: "marginAftSplDisc", hide: !hideSDRColumns},
        { colId: "marginAftSplDiscPercent", hide: !hideSDRColumns},
        { colId: "gestureToCustomer", hide: !hideSDRColumns},
        { colId: "gesture", hide: !hideSDRColumns},
      ]
    })
    gridRef.current.api.refreshCells();
  };

  useEffect(() => {
    props.successMsg(successMsg);
  }, [successMsg]);

  useImperativeHandle(ref, () => ({
    handleSDPSubmit: handleSDPSubmit,
    handleUpdateSDPCellValue: handleUpdateSDPCellValue,
    handleSDPApprove: handleSDPApprove,
    handleSDPRejected: handleSDPRejected,
    toggleSDPColumns: toggleSDPColumns,
    toggleSDRColumns: toggleSDRColumns,
    toggleAutoSize: toggleAutoSize,
  }));
const handleSDPApprove=()=>{

}
const handleSDPRejected=()=>{

}
  const handleDownloadAttachment = async (selectedDocument) => {
    let id = selectedDocument?.id;
    const download = await OAuthService.getDownload(
      discountUrl + `api/downloadOrderFile?orderAttachmentId=${id}`
    );
    const blob = download?.data;
    if (blob) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: "application/octet-stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = selectedDocument.attachmentName;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };
// const onFirstDataRendered = useCallback(() => {
//   setTimeout(() => {
//     if (!gridRef?.current) return;

//     const allColumnIds = [];
//     gridRef.current.columnApi.getAllColumns().forEach((column) => {
//       allColumnIds.push(column.getColId());
//     });

//     gridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
//   }, 200); 
// }, []);
// useEffect(() => {
//   if (rowData?.length && gridRef?.current) {
//     const allColumnIds = [];
//     gridRef.current.columnApi.getAllColumns().forEach((column) => {
//       allColumnIds.push(column.getColId());
//     });
//     gridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
//   }
// }, [rowData])
  
  useEffect(() => {
    const options = {
      style: "decimal", // Other options: 'currency', 'percent', etc.
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    if (selectedRows && selectedRows.length > 0) {
      let allRows = [];

      selectedRows.map((grp) => {
        allRows.push(grp);
        return grp;
      });
      if (allRows.length > 0) {
        let totalPrice = allRows.reduce(
          (total, row) => total + row?.totalLpWg1Wg2,
          0
        );
        let totalRCBAfterSDR = allRows.reduce(
          (total, row) => total + row?.nmeRcblAfterSdr,
          0
        );
        let totalRCBLasPerPDS = allRows.reduce(
          (total, row) => total + row?.nmeRcblStd,
          0
        );
        let totalGestureToCustomer = totalRCBLasPerPDS - totalRCBAfterSDR;
        let totalPercentageGestureToCustomer =
          (totalGestureToCustomer / totalRCBLasPerPDS) * 100;
        let totalMarginAsPerPDS = allRows.reduce(
          (a, b) => Number(a + b?.stdMargin),
          0
        );
        let totalAfterSDR = allRows.reduce(
          (a, b) => Number(a + b?.marginAftSplDisc),
          0
        );
        let totalPercentageMargin = (totalAfterSDR / totalRCBAfterSDR) * 100;
        let TotalOrder = allRows.length;
        let totalPblAsPerPds = allRows.reduce(
          (a, b) => Number(a + b?.nmePblStd),
          0
        );
        let totalPBLAfterSDP = allRows.reduce(
          (a, b) => Number(a + b?.nmePblAfterSdr),
          0
        );
        let totalGestureFromFac = allRows.reduce(
          (a, b) => Number(a + b?.gestureToPbl),
          0
        );

        let totalPercentageGestureToPbl =
          (totalGestureFromFac / totalPblAsPerPds) * 100;

        setTotalsGroup({
          ...totalsGroup,
          totalListPrice:
            totalPrice && totalPrice !== 0
              ? Number(totalPrice).toLocaleString("en-US", options)
              :0.00,
          totalRCBLSTD:
            totalRCBLasPerPDS && totalRCBLasPerPDS !== 0
              ? Number(totalRCBLasPerPDS).toLocaleString("en-US", options)
              :0.00,
          totalRCBAftSDR:
            totalRCBAfterSDR !== 0 && totalAfterSDR
              ? Number(totalRCBAfterSDR).toLocaleString("en-US", options)
              :0.00,
          // totalRCBAfterSDR:Number(totalrcbl.toFixed(3)) : 0.00,
          totalGestureCustomer:
            totalGestureToCustomer !== 0 && totalGestureToCustomer
              ? Number(totalGestureToCustomer).toLocaleString("en-US", options)
              :0.00,
          perGestureCust:
            totalPercentageGestureToCustomer !== 0 &&
            totalPercentageGestureToCustomer
              ? Number(totalPercentageGestureToCustomer).toFixed(3)
              :0.00,
          totalMarginPDS:
            totalMarginAsPerPDS !== 0 && totalMarginAsPerPDS
              ? Number(totalMarginAsPerPDS).toLocaleString("en-US", options)
              :0.00,
          totalMarginPercentage:
            totalPercentageMargin !== 0 && totalPercentageMargin
              ? Number(totalPercentageMargin).toFixed(3)
              :0.00,
          totalMarginAftSDR:
            totalAfterSDR !== 0 && totalAfterSDR
              ? Number(totalAfterSDR).toLocaleString("en-US", options)
              :0.00,
          TotalOrder:
            TotalOrder !== 0 && TotalOrder
              ? Number(TotalOrder).toLocaleString("en-US", options)
              :0.00,
          totalPBLPDS:
            totalPblAsPerPds !== 0 && totalPblAsPerPds
              ? Number(totalPblAsPerPds).toLocaleString("en-US", options)
              :0.00,
          totalPBLAftSDP:
            totalPBLAfterSDP !== 0 && totalPBLAfterSDP
              ? Number(totalPBLAfterSDP).toLocaleString("en-US", options)
              :0.00,
          totalGestureFac:
            totalGestureFromFac !== 0 && totalGestureFromFac
              ? Number(totalGestureFromFac).toLocaleString("en-US", options)
              :0.00,
          totalPercentageGesture:
            totalPercentageGestureToPbl !== 0 && totalPercentageGestureToPbl
              ? Number(totalPercentageGestureToPbl).toFixed(3)
              :0.00,
        });
      }
    } else {
       setTotalsGroup({
          ...totalsGroup,
          totalListPrice:
            totalPrice && totalPrice !== 0
              ? Number(totalPrice).toLocaleString("en-US", options)
              :0.00,
          totalRCBLSTD:
            totalRCBLasPerPDS && totalRCBLasPerPDS !== 0
              ? Number(totalRCBLasPerPDS).toLocaleString("en-US", options)
              :0.00,
          totalRCBAftSDR:
            totalRCBAfterSDR !== 0 && totalAfterSDR
              ? Number(totalRCBAfterSDR).toLocaleString("en-US", options)
              :0.00,
          // totalRCBAfterSDR:Number(totalrcbl.toFixed(3)) : 0.00,
          totalGestureCustomer:
            totalGestureToCustomer !== 0 && totalGestureToCustomer
              ? Number(totalGestureToCustomer).toLocaleString("en-US", options)
              :0.00,
          perGestureCust:
            totalPercentageGestureToCustomer !== 0 &&
            totalPercentageGestureToCustomer
              ? Number(totalPercentageGestureToCustomer).toFixed(3)
              :0.00,
          totalMarginPDS:
            totalMarginAsPerPDS !== 0 && totalMarginAsPerPDS
              ? Number(totalMarginAsPerPDS).toLocaleString("en-US", options)
              :0.00,
          totalMarginPercentage:
            totalPercentageMargin !== 0 && totalPercentageMargin
              ? Number(totalPercentageMargin).toFixed(3)
              :0.00,
          totalMarginAftSDR:
            totalAfterSDR !== 0 && totalAfterSDR
              ? Number(totalAfterSDR).toLocaleString("en-US", options)
              :0.00,
          TotalOrder:
            TotalOrder !== 0 && TotalOrder
              ? Number(TotalOrder).toLocaleString("en-US", options)
              :0.00,
          totalPBLPDS:
            totalPblAsPerPds !== 0 && totalPblAsPerPds
              ? Number(totalPblAsPerPds).toLocaleString("en-US", options)
              :0.00,
          totalPBLAftSDP:
            totalPBLAfterSDP !== 0 && totalPBLAfterSDP
              ? Number(totalPBLAfterSDP).toLocaleString("en-US", options)
              :0.00,
          totalGestureFac:
            totalGestureFromFac !== 0 && totalGestureFromFac
              ? Number(totalGestureFromFac).toLocaleString("en-US", options)
              :0.00,
          totalPercentageGesture:
            totalPercentageGestureToPbl !== 0 && totalPercentageGestureToPbl
              ? Number(totalPercentageGestureToPbl).toFixed(3)
              :0.00,
        });
    }
  }, [selectedRows]);
  const isCellEditable = useCallback(
    (params) => {
      const token = jwtDecode(localStorage.getItem("token"));
      const roleMD = token?.scope && token?.scope.includes("Rolle_MD");
      if (token?.scope?.includes("ROLE_ORDERPRO") ||  token?.scope?.includes("ROLE_SOPDIR")) {
        if (params.data.sdrStatus === "WAITING") {
          return true;
        }
      } else if (token?.scope?.includes("ROLE_MD")) {
        if (
          params.data.sdrStatus === "WAITING" ||
          params.data.sdrStatus === "PENDING" ||
          params.data.sdrStatus === "REJECTED" ||
          params.data.sdrStatus === "APPROVED"
        ) {
          return true;
        }
      } else {
        return false;
      }
      // return false;
    },
    [editableRow]
  );

  const columnTypes = useMemo(() => {
    return {
      editableColumn: {
        editable: (params) => {
          return isCellEditable(params);
        },
      },
    };
  }, [editableRow]);
const cleanSearchQuery = (query) => {
  for (let key in query) {
    if (query[key] === "" || query[key] === null || query[key] === undefined) {
      delete query[key];
    }
  }
  return query;
};
  const loadSDPDiscount = async (query) => {
    gridApi?.showLoadingOverlay();
    
    try {
           const searchQuery = { ...query };
           if (searchQuery.specialDiscStatus === "All") {
             delete searchQuery.specialDiscStatus;
           }
           if (searchQuery.specialDiscStatus === "PENDING") {
             searchQuery.sortBy = "requestedDate";
           } else if (searchQuery.specialDiscStatus === "APPROVED") {
             searchQuery.sortBy = "approvedDate";
           } else {
             searchQuery.sortBy = "createdDate";
           }
           const updatedSearchQuery = cleanSearchQuery(searchQuery);
           const url = await OAuthService.addData(
             discountUrl + "api/searchSpecialDiscount",
             updatedSearchQuery,
           );
         const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
               const userlist = await OAuthService.getList(
                 userUrl + `?sort=firstName,asc&size=1000`
               );
               const users = [];
               userlist.data?._embedded?.users.map((data, key) => {
                 data.name = data.firstName + " " + data.lastName;
                 users[data.email] = data.name;
                 return data;
               });
               if (url?.data?.content) {
                 let discounts = url?.data?.content.map((discount) => {
                   discount.createdByUser = users[discount.createdByUser]
                     ? users[discount.createdByUser]
                     : discount.createdByUser;
                    discount.approvedBy = users[discount.approvedBy]
                     ? users[discount.approvedBy]
                     : discount.approvedBy;
         
                   return discount;
                 });
                 setRowData(discounts);
                 props?.setDiscountCount(url?.data?.totalPages)
                   props.SDPCount();
      if (token?.scope?.includes("ROLE_MD")) {
        gridRef?.current?.columnApi?.applyColumnState({
          state: [{ colId: "decline", hide: true }],
        });
      } else {
        gridRef?.current?.columnApi?.applyColumnState({
          state: [{ colId: "decline", hide: false }],
        });
      }
      gridRef?.current?.api?.refreshCells();
               } else {
                 setRowData([]);
               }
 
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }finally {
    gridApi?.hideOverlay();
  }
  };
 const onSelectionChanged = (params) => {
      setSelectedRows(params?.api?.getSelectedRows());

  };
  const handleSuccessMsg = () => {
    setSuccessMsg("SDP comment saved succesfully");
    loadSDPDiscount(props.filterPagination);
  };

  const groupRowRendererParams = useMemo(() => {
    return {
      innerRenderer: GroupRowInnerRendererSDP,
      // checkbox: true,
      groupUseEntireRow: true,
      suppressCount: true,
      handleSuccessMsg: handleSuccessMsg,
    };
  });


  useEffect(() => {
    if(props.tabValue===1){
      if(gridApi){

        loadSDPDiscount(props.filterPagination);
      }

    }
  }, [props.filterPagination,gridApi]);

  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      filter: "agMultiColumnFilter",
      floatingFilter: true,
      resizable: true,
      flex: 1,
      enableRowGroup: true,
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    };
  }, []);
  const totalPrice = rowData.reduce((a, b) => Number(a + b.totalLpWg1Wg2), 0);
  const totalRCBLasPerPDS = rowData.reduce(
    (a, b) => Number(a + b.nmeRcblStd),
    0
  );
  const totalRCBAfterSDR = rowData.reduce(
    (a, b) => Number(a + b.nmeRcblAfterSdr),
    0
  );
  const totalGestureToCustomer = totalRCBLasPerPDS - totalRCBAfterSDR;
  const totalPercentageGestureToCustomer =
    (totalGestureToCustomer / totalRCBLasPerPDS) * 100;

  const totalMarginAsPerPDS = rowData.reduce(
    (a, b) => Number(a + b.stdMargin),
    0
  );
  const totalAfterSDR = rowData.reduce(
    (a, b) => Number(a + b.marginAftSplDisc),
    0
  );
  const totalPercentageMargin = (totalAfterSDR / totalRCBAfterSDR) * 100;

  const totalPblAsPerPds = rowData.reduce((a, b) => Number(a + b.nmePblStd), 0);
  const totalPBLAfterSDP = rowData.reduce(
    (a, b) => Number(a + b.nmePblAfterSdr),
    0
  );

  const totalGestureFromFac = rowData.reduce(
    (a, b) => Number(a + b.gestureToPbl),
    0
  );
  const totalPercentageGestureToPbl =
    (totalGestureFromFac / totalPblAsPerPds) * 100;

    const TotalOrder = rowData.length;

    const gridThemeClass = theme.palette.mode === 'dark' ? 'ag-theme-alpine-dark grid' : 'ag-theme-alpine grid';

  return (
    <>
      <div style={gridStyle} className={gridThemeClass}>
        {props.showAlert && (
          <Alert severity="error">Please select order first!</Alert>
        )}
        <AgGridReact
          columnDefs={columnDefsSDP}
          onGridReady={onGridReady}
          defaultColDef={defaultColDef}
          onSelectionChanged={onSelectionChanged}
          ref={gridRef}
          rowData={rowData}
          wrapHeaderText={true}
          autoHeaderHeight={true}
          onCellValueChanged={onCellValueChanged}
          domLayout={"autoHeight"}
          suppressRowTransform={true}
          editable={false}
          pagination={false}
          getRowId={(params) => params.data.id}
          // columnTypes={columnTypes}
          // onFirstDataRendered={onFirstDataRendered}
          onRowDoubleClicked={onRowDoubleClicked}
          onRowClicked={onRowClicked}
          floatingFilter={true}
          hideCheckbox={true}
          rowSelection="multiple"
          animateRows={true}
          headerHeight={28}
          rowHeight={22}
          cacheBlockSize={20}
          cacheOverflowSize={2}
          maxBlocksInCache={2}
          rowGroupPanelShow={"always"}
          onFirstDataRendered={onFirstDataRendered}
          onFilterChanged={onFilterChanged}
          onColumnMoved={onColumnStateChanged}
          onColumnPinned={onColumnStateChanged}
          onColumnVisible={onColumnStateChanged}
          onColumnResized={onColumnStateChanged}
          cellSelection={true}
          suppressRowClickSelection={true}
          onColumnRowGroupChanged={onColumnGroupChange}
          suppressDragLeaveHidesColumns={true}
        />
      </div>
    </>
  );
});
export default SDPDiscount;
